import { Controller } from "@hotwired/stimulus"

// Checkbox oznacza „zaproś linkiem": zaznaczony wysyła zaproszenie, odznaczony odsłania pola hasła
// i przełącza formularz w tryb natychmiastowego dodania użytkownika.
export default class extends Controller {
  static targets = [
    "addUserInput",
    "inviteLabel",
    "addUserLabel",
    "field",
    "passwordFields",
    "departments",
    "role"
  ]

  static values = { allDepartmentsRoles: Array }

  connect() {
    this.refreshDepartments()
  }

  toggle(event) {
    const isAddUser = !event.target.checked
    this.addUserInputTarget.value = isAddUser ? "1" : ""
    this.inviteLabelTargets.forEach(el => el.classList.toggle("hidden", isAddUser))
    this.addUserLabelTargets.forEach(el => el.classList.toggle("hidden", !isAddUser))
    this.fieldTargets.forEach(field => { field.disabled = !isAddUser })
    this.passwordFieldsTarget.classList.toggle("hidden", !isAddUser)
  }

  // role obejmujące wszystkie działy (oraz brak wyboru roli) nie mają czego ograniczać
  refreshDepartments() {
    this.departmentsTarget.classList.toggle("hidden", this.allDepartmentsRolesValue.includes(this.roleTarget.value))
  }
}
